import { _Page_liquid } from "../../@types/shopify";

const initPageCard = ($el: HTMLElement, $refs: Record<string, HTMLElement>, pageHandle: string) => {
  const random_id = utils.shortUUID();

  const page =
    _pages[pageHandle] || utils.JSONParse<_Page_liquid>(document.querySelector(`[data-page-data="${pageHandle}"]`)?.innerHTML);

  const state = window.Alpine.reactive({
    random_id,
    hydrated: true,
    ...(page ?? {}),
    url: page?.url ?? `/pages/${page?.handle}`,
  });

  const getDynamicValue = (content: string) => {
    return utils.getBracketInputDynamicValue(content, state);
  };

  const getDynamicValueWithFallbacks = (content: string) => {
    return content.split(",")?.reduce((acc, item) => {
      acc ||= utils.getBracketInputDynamicValue(item.trim(), state);
      return acc;
    }, "");
  };

  const getDynamicText = (content: string) => {
    return utils.getBracketInputDynamicPluralizedText(content, state);
  };

  const getContentLabels = (key: string) => {
    const labels = key.split(".").reduce<any>((acc, selector) => {
      if (!selector || acc === undefined || acc === null) return acc || "";

      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);

    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  };

  return {
    card: state,
    $el,
    getDynamicValue,
    getDynamicValueWithFallbacks,
    getDynamicText,
    getContentLabels,
  };
};

const fallbackHydrationQueue = new Set<HTMLElement>();

const hydratePageCardContent = ($el: HTMLElement) => {
  const card_handle = $el.getAttribute(`data-card-handle`);
  const page_handle = $el.getAttribute(`data-page-handle`);
  const page_id = $el.getAttribute(`data-page-id`);
  const classes = utils.JSONParse<string[]>($el.getAttribute(`data-card-classes`) ?? "[]");

  const node = document.querySelector(`[data-page-card='${card_handle}']`)?.cloneNode(true) as HTMLElement;

  if (!node) {
    fallbackHydrationQueue.add($el);
    return;
  }

  node?.removeAttribute(`data-page-card`);
  node?.setAttribute("data-page-handle", page_handle);
  node?.setAttribute("data-page-id", page_id);
  node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
    el.remove();
  });

  node.classList.add(...classes);
  $el.parentNode?.replaceChild(node, $el);
};

document.addEventListener("modalsLoaded", () => {
  fallbackHydrationQueue.forEach((el) => {
    hydratePageCardContent(el);
  });
  fallbackHydrationQueue.clear();
});

const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.target instanceof HTMLElement) {
        hydratePageCardContent(entry.target);
        observer.unobserve(entry.target);
      }
    }
  },
  { rootMargin: "300px 300px 300px 300px" }
);

const hydratePageCard = ($el: HTMLElement) => {
  if ($el.hasAttribute("data-intersected")) {
    hydratePageCardContent($el);
    return;
  }

  observer.observe($el);
};

export type InitPageCard = typeof initPageCard;
export type HydratePageCard = typeof hydratePageCard;

window._sections["initPageCard"] = initPageCard;
window._sections["hydratePageCard"] = hydratePageCard;
